import axios from 'axios';

const baseURL =
    process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_API_BASE_URL
        : 'http://localhost:5001/api/v1/';

const instance = axios.create({
    baseURL,
});

export default instance;
